import BeeModel from "Components/Public/BeeScene";
import { Component, ErrorInfo, ReactNode } from "react";

// エラーバウンダリーコンポーネント
class BeeModelErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.warn('BeeModel rendering error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // エラーが発生した場合は白い背景を表示
      return (
        <div className="w-full h-full bg-white flex items-center justify-center">
          <div className="text-gray-400 text-sm text-center">
            {/* 空白の代替表示 */}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const HeroArea = ({ getLocation }: { getLocation: () => Promise<void> }) => (
  <>
    <div className="px-4 flex justify-between items-center">
      <p className="">
        ローカルクーポンをゲットして、<br />寄り道をもっと楽しく。
      </p>
      <div className="w-20 h-20 -mt-4">
        <BeeModelErrorBoundary>
          <BeeModel />
        </BeeModelErrorBoundary>
      </div>
    </div>
    <div className="mt-4 px-4">
      <a href="/#map">
        <button
          className="w-full flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold rounded-md text-white bg-image_color"
          style={{ transition: "all 0.2s ease 0s" }}
          onClick={getLocation}
        >
          クーポンを探す
        </button>
      </a>
    </div>
  </>
);

export default HeroArea;
